// #region Imports

import * as $ from "jquery";
import * as responsiveness from './responsiveness';

// #endregion Imports

// #region Exports

export function initialize(): void {
    wireAnchorLinks();
}

// #endregion Exports

// #region Private functions

function wireAnchorLinks(): void {
    $("a[href*=\"#\"]").click(gotoAnchorLink);
}

function gotoAnchorLink(e: any): void {
    const targetId = $(this).attr("href");
    if (targetId === "#") {
        e.preventDefault();
        return;
    }

    if (targetId.length > 0 && targetId.substr(0, 1) !== '#') {
        return;
    }

    e.preventDefault();

    const $target = $(targetId);
    let position = $target.offset().top - $(".header").outerHeight();
    const isDownwardsScrolling = $target.offset().top > window.pageYOffset;

    /*---START OF DOCUMENT PAGE SPECIFIC STUFF ---*/
    /*Minimized header?*/
    if( $('body').hasClass('with-minimized-header')){
        position -= 35;
    }
    /*Soon a minimized header?*/
    else if( $('body').hasClass('js-document') && isDownwardsScrolling){        
        //position += 35;
    }

    if(document.getElementById("exam-mode-container")){
        position -=60
    }

    /*Sticky document tools*/
    const $fixedXmlDocumentHeader = $(".document-sticky__document-header");
    if($fixedXmlDocumentHeader.length > 0) {
        position -= $fixedXmlDocumentHeader.outerHeight();
    }
    const $fixedXmlDocumentContentTogglerMenu = $(".document-sticky__content-toggler-menu");
    if($fixedXmlDocumentContentTogglerMenu.length > 0) {
        if($fixedXmlDocumentContentTogglerMenu.is(':visible')){
            position -= $fixedXmlDocumentContentTogglerMenu.outerHeight();
        }
    }
    /*---END OF DOCUMENT PAGE SPECIFIC STUFF ---*/

    if(responsiveness.smallerThan(responsiveness.TABLET_LANDSCAPE)) {
        position -= 60;
    }
    $("html, body").animate({ scrollTop: position }, 500);
}

// #endregion Private functions